export default __webpack_public_path__ + "static/av-piece-1-05a10cf2523e9420084e6c6865ebc77e.jpg";